import { Plugin } from 'ckeditor5';
import FileManagerUI from './FileManagerUI';
import FileManagerEditing from './FileManagerEditing';

export default class FileManager extends Plugin {
	static get requires() {
		return [ FileManagerUI ];
	}
}